//import config from 'config';
import {
    handleResponse,
    requestOptions
} from '@/_helpers';


export const expenseTypeService = {
    getAll,
    getExpenseTypesOfBuilding,
    getById,
    addExpenseType,
    updateExpenseType,
    deleteExpenseType,
};

function getById(id) {
    return fetch('/api/expenseTypes/' + id, requestOptions.get())
        .then(handleResponse);
}

function getAll() {
    return fetch('/api/expenseTypes', requestOptions.get())
        .then(handleResponse);
}

function getExpenseTypesOfBuilding(buildingId) {
    return fetch('/api/expenseTypes/building?id=' + buildingId, requestOptions.get())
        .then(handleResponse);
}

function addExpenseType(name, buildingId, vatPercentage) {
    return fetch('/api/expenseTypes', requestOptions.post({
            name,
        buildingId,
        vatPercentage
        }))
        .then(handleResponse)
        .then(() => {
            return true;
        });
}

function updateExpenseType(id, name, buildingId, vatPercentage) {
    return fetch('/api/expenseTypes/' + id, requestOptions.put({
            id,
            name,
        buildingId,
        vatPercentage
        }))
        .then(handleResponse)
        .then(() => {
            return true;
        });
}

function deleteExpenseType(id) {
    return fetch('/api/expenseTypes/' + id, requestOptions.delete({
            id
        }))
        .then(handleResponse)
        .then(() => {
            return true;
        });
}